import { FC, useRef } from 'react'
import { LockedFeaturesUpsellContentType } from '../../../constants/lockedFeatures'
import { PlanType } from '@dtx-company/true-common/src/types/planType'
import { PromoAsset } from '../../PromoAsset/PromoAsset'
import dynamic from 'next/dynamic'

const PlanPurchaseExperienceDialog = dynamic(
  () => import('../../PlanPurchaseExperienceDialog').then(mod => mod.PlanPurchaseExperienceDialog),
  { ssr: false }
)

interface PaymentModalProps {
  open: boolean
  onClose: (reason: 'success' | 'dismiss') => void
  lockPlanType: PlanType
  lockContent?: LockedFeaturesUpsellContentType
}

export const PaymentModal: FC<PaymentModalProps> = ({
  open,
  onClose,
  lockPlanType,
  lockContent
}: PaymentModalProps) => {
  const ref = useRef<HTMLDivElement>(null)

  return (
    <>
      {open && (
        <PlanPurchaseExperienceDialog
          ref={ref}
          open={open}
          onClose={() => {
            onClose('dismiss')
          }}
          planType={lockPlanType}
          onSuccessfulCheckout={() => {
            onClose('success')
          }}
          promoHeading={lockContent?.header}
          promoAsset={lockContent?.src ? <PromoAsset graphic={lockContent} /> : undefined}
          promoBackgroundImageUrl={lockContent?.bg}
          promoHideCompanies={lockContent?.hideCompanies}
          customHeadingText={lockContent?.customHeadingText}
        />
      )}
    </>
  )
}
